import jQuery from "vendor/jquery";
import $ from "vendor/jquery";
import spartaUILayersUtility from "global/sparta-ui-layers-utility";
import _ from "vendor/lodash";
import handlebarsRuntime from "vendor/handlebars-runtime";
import hb from "vendor/handlebars-runtime";
import Module from "global/sparta-module-utility";
import spartaEventsUtility from "global/sparta-events-utility";
import Handlebars from "vendor/handlebars";
import Templates from "global/sparta-templates-utility";
import "css!modules/global/global-social-module/3.2.0/css/global-social-module.scss.css";

const scope = {};
class globalSocialModuleTemplates extends Templates {
  constructor() {
    super();
    scope.templates = [{ name: 'global-social-module', precompiled: {"1":function(container,depth0,helpers,partials,data) {
    return "<script>\n$(document).ready(function() {\n    boaSocialUtilJS.init();\n});\n</script>\n";
},"compiler":[7,">= 4.0.0"],"main":function(container,depth0,helpers,partials,data) {
    var stack1, alias1=depth0 != null ? depth0 : {}, alias2=helpers.helperMissing;

  return "\n\n\n<div class=\"boa-social-target\" data-sparta=\"Sparta\" data-global-social-module-version=\"v3.1.0\" data-config='"
    + container.escapeExpression((helpers.json || (depth0 && depth0.json) || alias2).call(alias1,((stack1 = (depth0 != null ? depth0.globalContent : depth0)) != null ? stack1.socialDefaults : stack1),{"name":"json","hash":{},"data":data}))
    + "'></div>\n\n"
    + ((stack1 = (helpers.compare || (depth0 && depth0.compare) || alias2).call(alias1,((stack1 = (depth0 != null ? depth0.module : depth0)) != null ? stack1.externalSite : stack1),"==",true,{"name":"compare","hash":{},"fn":container.program(1, data, 0),"inverse":container.noop,"data":data})) != null ? stack1 : "");
},"useData":true} }];
  }

  get templates() { return scope.templates; }
  get(templateName) {
    return Handlebars.template(_.find(this.templates, {
      name: templateName
    }).precompiled);
  }
};

export default new globalSocialModuleTemplates();
